var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_vm._v(" 共搜索到 "+_vm._s(_vm.total)+" 条 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }